export * as DetailActions from './DetailActions';
export DetailReducer from './DetailReducer';

export DetailValue from './DetailValue';
export DetailLeftIcon from './DetailLeftIcon';
export ActionsRow from './ActionsRow';
